export function excelFuelReportColumns() {
  const tYear = { key: 'tYear', header: 'År', width: 10 }
  const tMonth = { key: 'tMonth', header: 'Måned', width: 10 }
  const consolidatedInvoiceAgreement = { key: 'consolidatedInvoiceAgreement', header: 'Samlefaktura', width: 15 }
  const amountIncVat = { key: 'amountIncVat', header: 'Beløp inkl. MVA', width: 15 }
  const volume = { key: 'volume', header: 'Mengde', width: 15 }

  return [tYear, tMonth, consolidatedInvoiceAgreement, amountIncVat, volume]
}

export function excelFuelReportDetailsColumns() {
  const regNo = { key: 'regNo', header: 'Regnr', width: 15 }
  const vehicleId = { key: 'vehicleId', header: 'Kjøretøy ID', width: 15 }
  const invoiceGroupingDescription = { key: 'invoiceGroupingDescription', header: 'Fakturagruppe', width: 25 }
  const carDescription = { key: 'carDescription', header: 'Objekt', width: 40 }
  const driverName = { key: 'driverName', header: 'Sjåfør', width: 20 }
  const amountIncVat = { key: 'amountIncVat', header: 'Beløp inkl. MVA', width: 15 }
  const volume = { key: 'volume', header: 'Mengde', width: 15 }

  return [regNo, vehicleId, invoiceGroupingDescription, carDescription, driverName, amountIncVat, volume]
}

export function excelFuelReportExpenseDetailsColumns() {
  const transactionDate = { key: 'transactionDate', header: 'Dato', width: 15 }
  const transactionTime = { key: 'transactionTime', header: 'Tidspunkt', width: 15 }
  const referenceNo = { key: 'referenceNo', header: 'Kortnr.', width: 20 }
  const retailStationName = { key: 'retailStationName', header: 'Stasjon', width: 25 }
  const productDescription = { key: 'productDescription', header: 'Produkt', width: 20 }
  const amountIncVat = { key: 'amountIncVat', header: 'Beløp inkl. mva', width: 15 }
  const volume = { key: 'volume', header: 'Mengde', width: 15 }
  const paidCostPerLiter = { key: 'paidCostPerLiter', header: 'Pris p/enhet', width: 15 }
  const regKm = { key: 'regKm', header: 'Kilometerstand', width: 15 }

  return [
    transactionDate,
    transactionTime,
    referenceNo,
    retailStationName,
    productDescription,
    amountIncVat,
    volume,
    paidCostPerLiter,
    regKm,
  ]
}
